import React from 'react';
import { Select2 } from '@economic/taco';
import { useCollectionQuery } from '~/app/shared/hooks/useCollectionQuery';
import { AccountModel } from '~/app/views/Accounts';

export const AccountFromCoADropdown = props => {
    const { data } = useCollectionQuery<AccountModel>('/accounts/collection?filter=typeid$eq:2&returnAll=true');

    return (
        <Select2 className="w-20" {...props}>
            {data.map(item => (
                <Select2.Option key={item.number} value={item.number}>
                    {item.number + ' - ' + item.name}
                </Select2.Option>
            ))}
        </Select2>
    );
};
